import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Modal, Button, Row, Col, Alert } from "react-bootstrap";
import FieldInput from "../../global/form/FieldInput";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { CreateTicker, UpdateTicker } from "../../../api/News";

export default function ModalTicker(props) {
  const [t] = useTranslation(["global", "news", "modalCreateStudent"]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);

  const tickerInfo = props.tickerDetails || {
    name: "",
    description: "",
  };

  const validateSchema = Yup.object().shape({
    name: Yup.string().required(
      t("news:modalCategory.name") +
      " " +
      t("modalCreateStudent:labels.isRequired")
    )
  });

  /**
   * Save the category
   * @param {*} values
   */
  const saveTicker = (values) => {
    let payload = {
      ticker: values.name,
    }
    setSaving(true);
    if (tickerInfo.id) {
      payload.id = tickerInfo.id;
      updateTicker(payload);
    } else {
      createTicker(payload);
    }
  }

  /**
   * Create a new category
   * @param {object} values
   */
  const createTicker = (payload) => {
    CreateTicker(payload)
      .then((response) => {
        if (!response.status) {
          setError(response.error.description);
          setTimeout(() => setError(false), 3000);
          return;
        }
        props.getTickers();
        props.setShowModalTicker(false);
      })
      .finally(() => {
        setSaving(false);
      }
      );
  }

  /**
   * Update a category
   * @param {object} payload
   */
  const updateTicker = (payload) => {
    UpdateTicker(payload)
      .then((response) => {
        if (!response.status) {
          setError(response.error.description);
          setTimeout(() => setError(false), 3000);
          return;
        }
        props.getTickers();
        props.setShowModalTicker(false);
      }
      )
      .finally(() => {
        setSaving(false);
      });
  }

  return (
    <Modal
      show={props.showModalTicker}
      bsSize="large"
      aria-labelledby="contained-modal-title-lg"
    >
      <Modal.Header>
        <Modal.Title className="modal-title">
          {tickerInfo.id ?
            t("news:modalTicker.editTicker")
            : t("news:tickerPage.create")
          }
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={tickerInfo}
        validationSchema={validateSchema}
        onSubmit={async (values) => {
          await new Promise((r) => setTimeout(r, 500));
          !saving ? saveTicker(values) : null;
        }}
      >
        {() => (
          <Form>
            <Modal.Body>
              {/* Name */}
              <Row>
                <Col md={12}>
                  <FieldInput
                    label={t("news:modalTicker.title")}
                    placeholder=""
                    name="name"
                    type="text"
                    required={true}
                    maxlength={490}
                  />
                </Col>
              </Row>
              {error && (
                <Row>
                  <Col md={12}>
                    <Alert variant="warning">{error}</Alert>
                  </Col>
                </Row>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="outline-secondary"
                onClick={() => props.setShowModalTicker(false)}
                disabled={saving}
              >
                {t("global:buttons.cancel")}
              </Button>
              <Button
                type="submit"
                disabled={saving}
              >
                {saving ?
                  t("global:buttons.saving")
                  :
                  tickerInfo.id ?
                    t("global:buttons.save")
                    :
                    t("news:tickerPage.create")
                }
              </Button>
            </Modal.Footer>
          </Form>)}
      </Formik>
    </Modal>
  );
}

ModalTicker.propTypes = {
  showModalTicker: PropTypes.bool, //Required
  setShowModalTicker: PropTypes.func, //Required
  getTickers: PropTypes.func, //Required
  tickerDetails: PropTypes.object,
};
